import React from 'react';
import SignUpForm from '../../components/signUpForm';


const SignUpPage = () => {
  return (
    <div className="login-page">
      <div className="left-panel">
        <p className="left-text">Login to upload and receive your edited videos instantly.</p>
      </div>

      <div className="right-panel">
          {/* Use LoginForm Component here */}
          <SignUpForm />
      </div>
    </div>
  );
};

export default SignUpPage;
